<template>
  <div>
    <div class="row row-cols-1 row-cols-md-3 gy-4 inner-gallery">
      <div
          v-for="(src, index) in imgs"
          :key="index"
          class="pic col"

          @click="() => showImg(index)"
      >
        <img :src="src" class="img-fluid" alt=""/>
      </div>
    </div>
    <vue-easy-lightbox
        moveDisabled
        :visible="visible"
        :imgs="imgs"
        @hide="handleHide"
    >
      <template v-slot:toolbar>&nbsp;</template>
    </vue-easy-lightbox>
  </div>
</template>

<script>
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: 'gallery',
  components: {
    VueEasyLightbox
  },
  props: {
    // img: {
    //     type: Array,
    //     required: true
    // },
    className: {
      type: String
    }
  },
  data() {
    return {
      // imgs: this.img,
      imgs: [
        "/images/temp/article-inner-img.png",
        "/images/temp/article-inner-img.png",
        "/images/temp/article-inner-img.png",
        "/images/temp/article-inner-img.png",
      ],
      visible: false,
      index: 0,
    }
  },
  methods: {
    showImg(index) {
      this.index = index
      this.visible = true
    },
    handleHide() {
      this.visible = false
    }
  }
}
</script>